// Product card — industrial / technical
import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ProductPlaceholder from "./ProductPlaceholder";

const ProductCard = ({ p }) => {
  if (!p) return null;
  return (
    <Link
      to={`/product/${p.slug}`}
      className="jt-card group block relative"
      data-testid={`product-card-${p.slug}`}
    >
      <div className="aspect-square overflow-hidden bg-white flex items-center justify-center">
        {p.photo_file ? (
          <img
            src={`/products/photos/${p.photo_file}`}
            alt={p.title}
            loading="lazy"
            className="w-full h-full object-contain p-4 group-hover:scale-[1.04] transition-transform duration-500"
          />
        ) : (
          <ProductPlaceholder title={p.title} className="w-full h-full" subtitle={p.category_slug?.replace(/-/g, " ")} />
        )}
      </div>
      <div className="p-4 border-t border-[var(--jt-border)] group-hover:border-[var(--jt-primary)] transition-colors">
        <div className="font-mono text-[0.65rem] tracking-[0.18em] uppercase text-[var(--jt-text-muted)]">
          {(p.category_title || "").split("Manufacturer")[0].split("Hand Tool")[0].trim() || p.category_slug}
        </div>
        <div className="mt-1 flex items-start justify-between gap-2">
          <h3 className="font-display font-bold text-base leading-tight line-clamp-2">{p.title}</h3>
          <ArrowUpRight className="w-4 h-4 mt-1 flex-shrink-0 text-[var(--jt-text-muted)] group-hover:text-[var(--jt-primary)] transition-colors" />
        </div>
        <div className="mt-2 font-mono text-[0.65rem] text-[var(--jt-text-muted)]">
          SKU&nbsp;·&nbsp;JT-{String(p.legacy_id || 0).padStart(4, "0")}
        </div>
      </div>
      {p.is_featured && (
        <div className="absolute top-3 left-3 bg-[var(--jt-primary)] text-white font-mono text-[0.6rem] tracking-widest uppercase px-2 py-0.5">
          Featured
        </div>
      )}
    </Link>
  );
};

export default ProductCard;
